import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ExpertiseCard from "../ExpertiseCard/ExpertiseCard";
import "./ExpertiseSection.css";

const ExpertiseSection = () => {
  const expertise = [
    {
      icon: "/icons/comprehensive-eye-exam.png",
      title: "Comprehensive Eye Exams",
      description: "Precision diagnostics with advanced imaging to protect and preserve your vision.",
    },
    {
      icon: "/icons/custom-eyewear-fitting.png",
      title: "Designer Eyeglasses and Sunglasses",
      description: "Stylish frames that reflect your personality and elevate your look.",
    },
    {
      icon: "/icons/techno-driven-care.png",
      title: "Contact Lenses",
      description: " Comfortable and convenient lenses designed for your lifestyle",
    },
    {
      icon: "/icons/sports&safety-glasses.png",
      title: "Sports and Safety Glasses",
      description: "Durable eyewear that protects your eyes while keeping you active and safe.",
    },
  ];

  return (
    <section className="expertise-section">
      <Container>
        <h2 className="text-center expertise-heading mb-5">
          Our <span>Expertise</span>
        </h2>
        <Row className="justify-content-center g-4">
          {expertise.map((item, idx) => (
            <Col key={idx} xs={12} sm={6} lg={3}>
              <ExpertiseCard {...item} />
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default ExpertiseSection;
